module.exports = __webpack_public_path__ + "static/media/信息变更申请表（航校）.2c8044e4.docx";